/**
 * Token de WebSocket en memoria (no en localStorage ni cookies).
 * Se recibe tras el login y autentica Socket.IO con Express.
 * Se pierde al recargar la página (se renueva con checkSession).
 */
let token: string | null = null;

export function setWsToken(t: string | null) {
    token = t;
}

export function getWsToken(): string | null {
    return token;
}
